export default {
    // DOC: https://vite-pwa-org.netlify.app/frameworks/vue.html#vue-2
    name: 'useRegisterSW',
    data() {
        return {
            updateSW: undefined,
            needsSWRefresh: false,
            isSWRefreshing: false
        }
    },
    async mounted() {
        try {
            const { registerSW } = await import('virtual:pwa-register')
            this.updateSW = registerSW({
                immediate: false,
                onOfflineReady() {},
                onNeedRefresh: () => {
                    this.needsSWRefresh = true;
                },
                onRegistered: (swRegistration) => {
                    if (swRegistration) {
                        this.handleSWManualUpdates(swRegistration)
                    }
                },
                onRegisterError() {}
            })
        }
        catch {
            console.log('PWA disabled.')
        }
    },
    methods: {
        updateServiceWorker() {
            this.isSWRefreshing = true;
            if (this.updateSW) {
                this.updateSW(true);
            }
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        },
        handleSWManualUpdates(swRegistration) {
            setInterval(() => {
                swRegistration.update()
            }, 60000)
        },
    }
}
